// extracted by mini-css-extract-plugin
export default {"arrowLeft":"pFKyCM","arrowRight":"fwhcAP"};